import { render, staticRenderFns } from "./TaskShare.vue?vue&type=template&id=70f0aa0f&scoped=true"
import script from "./TaskShare.vue?vue&type=script&lang=js"
export * from "./TaskShare.vue?vue&type=script&lang=js"
import style0 from "./TaskShare.vue?vue&type=style&index=0&id=70f0aa0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f0aa0f",
  null
  
)

export default component.exports